import axios from "axios";

export default {
  fetch: async (context: any) => {
    try {
      let res: any = await axios.get(
        "https://api.openweathermap.org/data/2.5/forecast?q=Ann Arbor,US&appid=1a540748116dfe5f88920d606b427aa4&units=imperial",
      );
      // http://openweathermap.org/img/w/03n.png
      const parsedList = res.data.list.map((item: any) => {
        const date = new Date(item.dt_txt + " UTC");
        item.dt_txt = date.toLocaleString();
        return item;
      });

      res = await axios.get(
        "https://api.openweathermap.org/data/2.5/weather?q=Ann Arbor,US&appid=1a540748116dfe5f88920d606b427aa4&units=imperial",
      );
      res.data.dt_txt = new Date().toLocaleString()
      parsedList.unshift(res.data)
      context.commit("setCurrent", res.data.main);
      context.commit("setWeather", parsedList);

      console.log(res);

      return Promise.resolve();
    } catch (error) {
      context.commit("setWeather", []);
      context.commit("setCurrent", {});
      return Promise.reject(error);
    }
    // this.list = .map((item: object) => {
    //   return item;
    // });
  },
  // create: (context: object, todoData) => {
  //   // stuff to create a new todo on the backend : CRUD CREATE ACTION
  // },
  // read: (context, id) => {
  //   // stuff to retrieve a particular todo data from the backend : CRUD READ ACTION
  // },
  // update: (context, todoData) => {
  //   // stuff to update a particular todo data to the backend : CRUD UPDATE ACTION
  // },
  // delete: (context, id) => {
  //   // stuff to erase a particular todo on the bockend : CRUD DELETE ACTION
  // },
};
